module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<section class="result-box hidden ';
 if ( result.paid ) print('paid') 
__p+='" data-id="'+
((__t=( result.id ))==null?'':__t)+
'">\n	\n	<div class="inner">\n		\n		';
 if ( result.rating > 0 ) { 
__p+='\n			<div class="result-box-overlay-right">\n				<span class="digit">'+
((__t=( Math.round( result.rating ) ))==null?'':__t)+
'%</span> Empfehlung\n			</div>\n		';
 } 
__p+='\n		\n		<div class="image">\n			';
 if ( result.image && result.paid ) { 
__p+='\n				<div class="inner" style="background-image: url(//tramino.s3.amazonaws.com'+
((__t=( result.image ))==null?'':__t)+
')"></div>\n			';
 } 
__p+='\n			<div class="tags_badges">\n				';
 if ( result.oeffnungszeiten0 ) { 
__p+='<span class="tag">Heute '+
((__t=( result.oeffnungszeiten0 ))==null?'':__t)+
'</span>';
 } 
__p+='\n				';
 if ( result.oeffnungszeiten1 ) { 
__p+='<span class="tag">Morgen '+
((__t=( result.oeffnungszeiten1 ))==null?'':__t)+
'</span>';
 } 
__p+='\n\n				';
 
					if ( $('.result-tabs').data("tags_badges") !== undefined ) {
						var tags_badges = $('.result-tabs').data("tags_badges").split(",");
						for (var i = 0; i < tags_badges.length; i++) {
							if ( result.tags[tags_badges[i]] ) { 
__p+='\n							<span class="tag tag'+
((__t=( tags_badges[i]))==null?'':__t)+
'">'+
((__t=( result.tags[tags_badges[i]] ))==null?'':__t)+
'</span>\n							';
}
						}
					}
				
__p+='\n			</div>\n		</div>\n\n		<div class="info">\n\n			<div class="logo" >\n				<div class="inner">\n				';
 if ( result.logo && result.paid ) { 
__p+='\n					<img src="https://'+
((__t=( window.Tramino.cdn || 'tramino.s3.amazonaws.com' ))==null?'':__t)+
''+
((__t=( result.logo ))==null?'':__t)+
'" width="200" height="150" loading="lazy">\n					';
 } 
__p+='\n				</div>\n			</div>\n\n\n				<div class="text">\n					<h2 '+
((__t=( ( result.name.length > 25 ) ? 'class="longname"' : '' ))==null?'':__t)+
'><a href="/partner/'+
((__t=( result.shortcut ))==null?'':__t)+
'.html" target="blank">'+
((__t=( result.name ))==null?'':__t)+
'</a></h2>\n					<h3 class="color">'+
((__t=( result.slogan ))==null?'':__t)+
'</h3>\n					<div class="foot">\n						<div class="address">'+
((__t=( result.street ))==null?'':__t)+
'';
 if ( result.district ) print( "<span class='district'>, " + result.district + "</span>" ) 
__p+='</div>\n						<div class="phone">Tel. '+
((__t=( result.phone ))==null?'':__t)+
'</div>\n					</div>\n				</div>\n\n				';
 if ( favorited ) { 
__p+='\n					<div class="favable on" data-item="clients-'+
((__t=( result.id ))==null?'':__t)+
'" title="gefällt mir nicht mehr"></div>\n				';
 } else { 
__p+='\n					<div class="favable" data-item="clients-'+
((__t=( result.id ))==null?'':__t)+
'" title="gefällt mir"></div>\n				';
 } 
__p+='\n\n				<div class="clear"></div>\n\n			</div>\n	</div>\n\n</section>\n';
}
return __p;
};


//////////////////
// WEBPACK FOOTER
// /Users/bm/app/code/jsapps/modules/reserva/templates/browser/ResultTemplate.html
// module id = 71
// module chunks = 0